const TagUtility = {
  getTagAssociationsForSelectedAlerts: (selectedAlerts, tagIds) => {
    const tagsAssociatedWithAllSelected = [];
    const tagsAssociatedWithSomeSelected = [];

    tagIds.forEach((tagId) => {
      const associatedAlerts = selectedAlerts.filter((alert) => alert.tagIds.includes(tagId));

      if (associatedAlerts.length === selectedAlerts.length) {
        tagsAssociatedWithAllSelected.push(tagId);
      } else if (associatedAlerts.length > 0) {
        tagsAssociatedWithSomeSelected.push(tagId);
      }
    });
    return { tagsAssociatedWithAllSelected, tagsAssociatedWithSomeSelected };
  },

  getTagAssociationsForSelectedDevices: (selectedDevices, tagIds) => {
    const tagsAssociatedWithAllSelected = [];
    const tagsAssociatedWithSomeSelected = [];

    tagIds.forEach((tagId) => {
      const associatedDevices = selectedDevices.filter((device) => device.tagIds.includes(tagId));

      if (associatedDevices.length === selectedDevices.length) {
        tagsAssociatedWithAllSelected.push(tagId);
      } else if (associatedDevices.length > 0) {
        tagsAssociatedWithSomeSelected.push(tagId);
      }
    });
    return { tagsAssociatedWithAllSelected, tagsAssociatedWithSomeSelected };
  },
};

export default TagUtility;
